<div class="row justify-content-center">
  <div class="col-12">

    <!-- Page Title -->
    <div class="row mt-5">
      <div class="col-12">
        <h1 class="header-title">Création d'un nouveau calcul</h1>
      </div>
    </div>


    <div class="row">
      <div class="col-12">
        <app-alert-messages></app-alert-messages>
      </div>
    </div>

    <!-- Title -->
    <div class="row mt-5">
      <div class="col-12">
        <label class="form-label"> <strong> Titre du calcul </strong></label>
        <input [class.is-invalid]="this.form.formElements.title.state === 'ERROR'"
          [class.is-valid]="this.form.formElements.title.state === 'VALID' || this.form.formElements.title.lifecycleStatus === 'SENDING'"
          [formControl]="getTitleFormControl()"
          [readOnly]="this.form.formElements.title.lifecycleStatus === 'SENDING' || this.form.formElements.title.lifecycleStatus === 'LOADING'"
          class="form-control"
          placeholder="Jean Tremblay - Vente d'actions"
          type="text">
        <div class="form-text">Entrez ici un titre pour le calcul. Par exemple, vous pouvez entrer le nom de
          votre client.
        </div>

        @if (this.form.formElements.title.helpMessages.length != 0) {
          <div
            [class.invalid-feedback]="this.form.formElements.title.state === 'ERROR'"
            [class.valid-feedback]="this.form.formElements.title.state === 'VALID'">
            @for (helpMessage of this.form.formElements.title.helpMessages; track helpMessage) {
              <p>{{ helpMessage }}</p>
            }
          </div>
        }
      </div>
    </div>

    <!-- Calculation choices -->
    <h4> Choisir le type de calcul </h4>


    <div class="row mt-5 justify-content-center">
      @for (cardCalculationDetail of this.cardCalculationDetails; track cardCalculationDetail) {
        <label class="col-auto" style="min-width: 300px; width: 300px; height: 525px;"
          id="calculation_keyname_{{ cardCalculationDetail.value }}">
          <input [formControl]="getCalculationKeynameFormControl()" class="card-input-element" type="radio"
            value="{{ cardCalculationDetail.value}}">
          <div class="card card-input mb-3 h-100 d-flex flex-column">
            <div class="row">
              <img [src]="cardCalculationDetail.iconPath" style="height: 200px;">
            </div>
            <div class="card-body flex-grow-1">
              <h5 class="card-title"><strong> {{ cardCalculationDetail.title }} </strong></h5>
              <p class="card-text">{{ cardCalculationDetail.text }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-center pb-4">
              <span> <i class="fas fa-check-circle"></i> </span>
            </div>
          </div>
        </label>
      }
    </div>

    <!-- Submit button -->
    <div class="row">
      <div class="col-12">
        <magieno-button [button]="this.form.getButton('CREATE')"></magieno-button>
      </div>
    </div>

  </div>
</div> <!-- / .row -->